// extracted by mini-css-extract-plugin
module.exports = {"container":"t8LcM","title":"e9yes","toggle":"je7rR","content":"uxkzx","right":"Wrz7Z","left":"hAE2S","up":"hKINO","down":"xd8bM"};